import { render, staticRenderFns } from "./AttributeBlock.vue?vue&type=template&id=4fffd99d&scoped=true&"
import script from "./AttributeBlock.vue?vue&type=script&lang=js&"
export * from "./AttributeBlock.vue?vue&type=script&lang=js&"
import style0 from "./AttributeBlock.vue?vue&type=style&index=0&id=4fffd99d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fffd99d",
  null
  
)

export default component.exports